import { Stack, Typography } from "@mui/material";
import { useSetThanksToYouParticipationMutation } from "Api/Mutations/Lead/useSetThanksToYouParticipationMutation";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import { PaperTitle } from "Components/Shared/PaperTitle";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { ProgramParticipationState } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { toast } from "sonner";

const RESOURCES = Resources.Components.Affiliate.ThanksToYou.Join;

/**
 * The Díky Tobě section for a person who refused the program in the registration wizard (ZS-1623):
 * they can join at any time, from then on as anyone else — earlier referrals are not restored.
 */
export const ThanksToYouJoinCard = () => {
  const { t } = useResource();
  const { mutate: join, isPending } = useSetThanksToYouParticipationMutation({
    onSuccess: () => toast.success(t(RESOURCES.JoinedToast)),
    onError: () => toast.error(t(Resources.Common.SaveError)),
  });

  const handleJoin = () => join({ state: ProgramParticipationState.OptedIn });

  return (
    <PrimaryPaper>
      <Stack gap={3}>
        <Stack gap={1}>
          <PaperTitle>{t(RESOURCES.Title)}</PaperTitle>
          <Typography>{t(RESOURCES.Text)}</Typography>
        </Stack>
        <PrimaryButton
          fullWidth
          variant="contained"
          color="primary"
          isLoading={isPending}
          onClick={handleJoin}
        >
          {t(RESOURCES.Button)}
        </PrimaryButton>
      </Stack>
    </PrimaryPaper>
  );
};
